import { GenIcon } from '../helpers/IconBase.es.js';

const AccountFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 12.9483C10.2711 12.9483 8.86977 11.547 8.86977 9.8181V8.253C8.86977 6.5241 10.2711 5.1228 12 5.1228C13.7289 5.1228 15.1311 6.5241 15.1311 8.253V9.8181C15.1311 11.547 13.7289 12.9483 12 12.9483ZM10.2212 13.2947L7.70572 14.7383C6.97402 15.155 6.52222 15.9344 6.52222 16.7768V17.36C6.52222 17.36 7.88392 19.2113 12.0005 19.2113C16.1171 19.2113 17.4779 17.36 17.4779 17.36V16.7768C17.4779 15.9344 17.027 15.155 16.2953 14.7383L13.7762 13.2965C13.7762 13.2965 13.0373 13.8482 12.0005 13.8482C10.9628 13.8482 10.2212 13.2947 10.2212 13.2947Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { AccountFilled };
